import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "../Redux/Reducers/AuthSlice";
import ThemeToggleButton from "../helper/ThemeToggleButton";
import webLogo from "../otherImages/white-logo-icon.png";
import webSideLogo from "../otherImages/logo.svg";
import profilePic from "../otherImages/profilePic.png";

const MasterLayout = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [sidebarActive, setSidebarActive] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`;
            }
          }
        });
      });
    };

    openActiveDropdown();
  }, [location.pathname]);

  const sidebarControl = () => setSidebarActive(!sidebarActive);
  const mobileMenuControl = () => setMobileMenu(!mobileMenu);

  const handleLogout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
      localStorage.removeItem("access_token");
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
      localStorage.removeItem("access_token");
      navigate("/");
    }
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
              ? "sidebar sidebar-open"
              : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type="button"
          className="sidebar-close-btn"
        >
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link className="sidebar-logo">
            <img src={webLogo} alt="site logo" className="light-logo" />
            <img src={webLogo} alt="site logo" className="dark-logo" />
            <img
              src={webSideLogo}
              alt="site logo"
              className="logo-icon"
              style={{ width: "40px" }}
            />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            <>
              <li>
                <NavLink
                  to="/users"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon
                    icon="mynaui:users-group-solid"
                    className="menu-icon"
                    width="28"
                    height="28"
                  />
                  <span>Users</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/products"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon
                    icon="material-symbols:service-toolbox-rounded"
                    className="menu-icon"
                    width="28"
                    height="28"
                  />
                  <span>Products</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/manage-orders"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon
                    icon="solar:box-bold"
                    className="menu-icon"
                    width="28"
                    height="28"
                  />
                  <span>Orders</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/manage-inventory"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon
                    icon="tabler:building-warehouse"
                    className="menu-icon"
                    width="28"
                    height="28"
                  />
                  <span>Inventory</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/email-templates"
                  onClick={() =>
                    window.dispatchEvent(new Event("emailTemplates:showList"))
                  }
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="ic:baseline-email" width="28" height="28" className="menu-icon" />
                  <span>Email Templates</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/free-tapes"
                  className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }
                >
                  <Icon icon="mdi:tape-measure" width="28" className="menu-icon" height="28" />
                  <span>Free Tapes</span>
                </NavLink>
              </li>
            </>  
          </ul>
        </div>
        <div className="bottomSide">
          <ul>
            <li>
              <button
                onClick={handleLogout}
                className="logout-btn"
                style={{
                  background: "none",
                  border: "none",
                  width: "100%",
                  textAlign: "left",
                  cursor: "pointer",
                  padding: "10px 16px",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  color: "inherit",
                }}
              >
                <Icon
                  icon="material-symbols:logout-rounded"
                  className="menu-icon"
                  width="28"
                  height="28"
                />
                <span>Log Out</span>
              </button>
            </li>
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button
                  type="button"
                  className="sidebar-toggle"
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />
                  ) : (
                    <Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type="button"
                  className="sidebar-mobile-toggle"
                >
                  <Icon icon="heroicons:bars-3-solid" className="icon" />
                </button>
              </div>
            </div>
            {/* <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <img
                      src={profilePic}
                      alt="image_user"
                      className="w-40-px h-40-px object-fit-cover rounded-circle"
                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                        </h6>
                      </div>
                    </div>
                    <ul className="to-top-list">
                      <li>
                        <button
                          onClick={handleLogout}
                          className="dropdown-item d-flex align-items-center gap-3"
                        >
                          <Icon icon="lucide:power" className="icon text-xl" />{" "}
                          Log Out
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>

        <div className="dashboard-main-body">{children}</div>
      </main>
    </section>
  );
};

export default MasterLayout;
